<template>
  <div class="v-stack gap-3 h-stretch">
    <a class="heading-title-2">Crew</a>
    <template v-if="!loading">
      <div class="h-stack gap-3 h-start">
        <div style="align-self: center">Show Pay:</div>
        <input type="checkbox" v-model="showPay" />
      </div>
      <div class="table">
        <div class="table-header user-row">
          <div class="text-left">Name</div>
          <div class="text-left" v-if="showPay">Pay</div>
          <div v-if="!showPay"></div>
          <div></div>
        </div>
        <div v-for="user in crew" :key="user._id" class="table-row user-row">
          <div
            class="text-left"
            @click="$router.push('/users/detail/' + user._id)"
          >
            {{ user.fullName }}
          </div>
          <div v-if="!showPay"></div>
          <div
            v-if="showPay"
            class="text-left"
            @click="$router.push('/users/detail/' + user._id)"
          >
            {{ user.pay }}
          </div>
          <div class="h-stack gap-3">
            <button
              @click="$router.push('/users/bonus/new/' + user._id)"
              class="add"
            >
              Bonus
            </button>
            <button
              @click="$router.push('/users/advance/new/' + user._id)"
              class="add"
            >
              Advance
            </button>
            <button
              @click="$router.push('/users/fine/new/' + user._id)"
              class="add"
            >
              Fine
            </button>
            <button
              class="add"
              @click="$router.push('/users/workday/new/' + user._id)"
            >
              Workday
            </button>
            <button
              class="add"
              @click="$router.push('/users/pay/new/' + user._id)"
            >
              Pay
            </button>
          </div>
        </div>
      </div>
    </template>
    <div v-else><span class="loader"></span></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import utils from "@/utils.js";
const moment = require("moment");

export default {
  data() {
    return {
      crew: [],
      showPay: false,
      format: utils.format,
      loading: true,
    };
  },
  methods: {
    ...mapActions(["getCrewWithPay"]),
  },
  mounted() {
    this.getCrewWithPay()
      .then((crew) => {
        this.crew = crew.sort((a, b) => a.fullName.localeCompare(b.fullName));
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
.user-row {
  grid-auto-columns: 1fr 1fr 550px !important;
  gap: 10px;
}

.user-row button {
  color: white;
}
</style>
